export function hardRefresh() {
    window?.location?.reload?.();
}
